var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "feedback-container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("平台建设")]),
              _c("el-breadcrumb-item", [_vm._v("服务中心")]),
              _c("el-breadcrumb-item", [_vm._v("意见反馈")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("意见反馈")]),
      _c(
        "el-card",
        { staticClass: "feedback-form" },
        [
          _c(
            "el-form",
            {
              ref: "feedbackForm",
              attrs: {
                model: _vm.feedbackForm,
                rules: _vm.rules,
                "label-width": "80px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标题", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入标题" },
                    model: {
                      value: _vm.feedbackForm.title,
                      callback: function($$v) {
                        _vm.$set(_vm.feedbackForm, "title", $$v)
                      },
                      expression: "feedbackForm.title"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "描述", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入描述"
                    },
                    model: {
                      value: _vm.feedbackForm.description,
                      callback: function($$v) {
                        _vm.$set(_vm.feedbackForm, "description", $$v)
                      },
                      expression: "feedbackForm.description"
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "form-footer" }, [
                _c("p", [_vm._v("感谢您宝贵的使用感受和改进意见")])
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "附件" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "#",
                        "http-request": _vm.handleUpload,
                        "on-success": _vm.handleUploadSuccess,
                        "on-preview": _vm.handlePreview,
                        "on-remove": _vm.handleRemove,
                        "before-upload": _vm.beforeUpload,
                        "before-remove": _vm.beforeRemove,
                        multiple: "",
                        limit: 3,
                        "on-exceed": _vm.handleExceed,
                        "file-list": _vm.fileList,
                        accept: ".jpg,.jpeg,.png,.gif"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip"
                        },
                        [_vm._v("只能上传jpg/png/gif文件，且不超过5MB")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.submitForm }
                    },
                    [_vm._v("提交")]
                  ),
                  _c("el-button", { on: { click: _vm.clearForm } }, [
                    _vm._v("清空")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "feedback-list" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "80" }
              }),
              _c("el-table-column", {
                attrs: { prop: "title", label: "标题", width: "150" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "description",
                  label: "描述",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "submitter", label: "提交人", width: "100" }
              }),
              _c("el-table-column", {
                attrs: { prop: "submit_time", label: "提交时间", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatTime(scope.row.submit_time)) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "reply",
                  label: "答复意见",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.reply || "暂无答复") +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "reply_time", label: "答复时间", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.reply_time
                                ? _vm.formatTime(scope.row.reply_time)
                                : "暂无"
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "attachments",
                  label: "附件",
                  width: "120",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.attachments &&
                        scope.row.attachments.length > 0
                          ? _c(
                              "div",
                              { staticClass: "image-thumbnail-container" },
                              [
                                _vm._l(
                                  scope.row.attachments.slice(0, 1),
                                  function(img, index) {
                                    return _c("el-image", {
                                      key: index,
                                      staticClass: "image-thumbnail",
                                      attrs: {
                                        src: img,
                                        "preview-src-list":
                                          scope.row.attachments,
                                        fit: "cover",
                                        "preview-teleported": "",
                                        "close-on-click-modal": true
                                      }
                                    })
                                  }
                                ),
                                scope.row.attachments.length > 1
                                  ? _c("span", { staticClass: "image-count" }, [
                                      _vm._v(
                                        "+" +
                                          _vm._s(scope.row.attachments.length)
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              2
                            )
                          : _c("span", [_vm._v("无图片")])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: { type: _vm.getStatusType(scope.row.status) }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.status) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "120", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.handleViewDetail(scope.row)
                              }
                            }
                          },
                          [_vm._v("查看详情")]
                        ),
                        scope.row.status !== "已完成" && _vm.isAuthorizedUser()
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function($event) {
                                    return _vm.handleReply(scope.row)
                                  }
                                }
                              },
                              [_vm._v("答复")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "答复反馈",
            visible: _vm.replyDrawerVisible,
            direction: "rtl",
            size: "30%",
            "destroy-on-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.replyDrawerVisible = $event
            }
          }
        },
        [
          _vm.currentReply
            ? _c(
                "div",
                { staticClass: "drawer-content" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "replyForm",
                      attrs: {
                        model: _vm.replyForm,
                        rules: _vm.replyRules,
                        "label-width": "80px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reply-title",
                          attrs: { label: "反馈标题" }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.currentReply.title))])]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "答复意见", prop: "reply" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 4,
                              placeholder: "请输入答复意见"
                            },
                            model: {
                              value: _vm.replyForm.reply,
                              callback: function($$v) {
                                _vm.$set(_vm.replyForm, "reply", $$v)
                              },
                              expression: "replyForm.reply"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.submitReply }
                            },
                            [_vm._v("提交答复")]
                          ),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  _vm.replyDrawerVisible = false
                                }
                              }
                            },
                            [_vm._v("取消")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "反馈详情",
            visible: _vm.drawerVisible,
            direction: "rtl",
            size: "30%",
            "destroy-on-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.drawerVisible = $event
            }
          }
        },
        [
          _vm.currentDetail
            ? _c("div", { staticClass: "drawer-content" }, [
                _c("div", { staticClass: "detail-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("标题：")]),
                  _c("span", [_vm._v(_vm._s(_vm.currentDetail.title))])
                ]),
                _c("div", { staticClass: "detail-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("描述：")]),
                  _c("span", [_vm._v(_vm._s(_vm.currentDetail.description))])
                ]),
                _c("div", { staticClass: "detail-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("提交人：")]),
                  _c("span", [_vm._v(_vm._s(_vm.currentDetail.submitter))])
                ]),
                _c("div", { staticClass: "detail-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("提交时间：")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.formatTime(_vm.currentDetail.submit_time))
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "detail-item" },
                  [
                    _c("span", { staticClass: "label" }, [_vm._v("状态：")]),
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getStatusType(_vm.currentDetail.status)
                        }
                      },
                      [_vm._v(_vm._s(_vm.currentDetail.status))]
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "detail-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("答复意见：")]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.currentDetail.reply || "暂无答复"))
                  ])
                ]),
                _vm.currentDetail.reply_time
                  ? _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("答复时间：")
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.formatTime(_vm.currentDetail.reply_time))
                        )
                      ])
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "detail-item" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("附件：")]),
                  _vm.currentDetail.attachments &&
                  _vm.currentDetail.attachments.length > 0
                    ? _c(
                        "div",
                        { staticClass: "attachments-preview" },
                        _vm._l(_vm.currentDetail.attachments, function(
                          img,
                          index
                        ) {
                          return _c("el-image", {
                            key: index,
                            staticClass: "detail-image",
                            attrs: {
                              src: img,
                              "preview-src-list": _vm.currentDetail.attachments,
                              fit: "cover",
                              "preview-teleported": ""
                            }
                          })
                        }),
                        1
                      )
                    : _c("span", [_vm._v("无图片")])
                ])
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }